import React from 'react';
import { CheckIcon, TrophyIcon } from 'lucide-react';
import { includedFeatures, tomos } from '../data/content';
export function WhatYouGet() {
  return <section id="contenido" className="w-full bg-blue-50 py-16 md:py-24" data-id="element-237" data-mp="zyj0fgnyi4ol">
      <div className="mx-auto w-full max-w-content px-5 text-center md:px-8" data-id="element-238" data-mp="l4w8qeqyi6ue">
        <p className="inline-flex items-center gap-2 rounded-full bg-white px-5 py-2 font-display text-xs font-extrabold uppercase tracking-[0.16em] text-blue-700 ring-1 ring-blue-200" data-id="element-239" data-mp="q3ha4hhy2wkf">
          <TrophyIcon className="h-4 w-4" aria-hidden="true" data-id="element-240" data-mp="1irmyrfc4d5pj" />
          MegaPack Método Mente Viva
        </p>

        <h2 className="mx-auto mt-7 max-w-3xl font-display text-[2rem] font-extrabold leading-[1.05] tracking-tight text-ink md:text-5xl" data-id="element-241" data-mp="1415vrrju67qj">
          6 Tomos + 3 Bonos
          <br data-id="element-242" data-mp="1wr4pi08z6t1j" />
          <span className="text-blue-600" data-id="element-243" data-mp="1wqcsckzqcn95">200 ejercicios — Todo resuelto.</span>
        </h2>

        <ul className="mt-12 flex flex-wrap justify-center gap-3" data-id="element-244" data-mp="21i4l926cz52g">
          {tomos.map(tomo => <li key={tomo.number} className={`flex h-32 w-24 flex-col justify-end rounded-xl p-3 text-left shadow-soft md:h-40 md:w-28 ${tomo.spine}`} data-id="element-245" data-mp="2vfaqzdj01ph6">
              <span className="block font-display text-[0.65rem] font-bold uppercase tracking-widest text-white/75" data-id="element-246" data-mp="3565cugsc2n23">
                Tomo {tomo.number}
              </span>
              <span className="mt-1 block font-display text-sm font-extrabold leading-tight text-white md:text-base" data-id="element-247" data-mp="30d2ezwgiwrg3">
                {tomo.short}
              </span>
            </li>)}
        </ul>

        <ol className="mx-auto mt-12 max-w-narrow divide-y divide-blue-100 overflow-hidden rounded-2xl bg-white text-left shadow-soft" data-id="element-248" data-mp="3o4hlm1fc1ux5">
          {tomos.map(tomo => <li key={tomo.number} className="flex gap-4 px-5 py-5 md:px-7" data-id="element-249" data-mp="3j66alndaxedc">
              <span className={`mt-1 h-11 w-2 shrink-0 rounded-full ${tomo.spine}`} aria-hidden="true" data-id="element-250" data-mp="1tr9pm6fmfd9x" />
              <span data-id="element-251" data-mp="1osye7r9ogupl">
                <span className="block font-display text-lg font-extrabold tracking-tight text-ink" data-id="element-252" data-mp="1otgklgq20pb8">
                  Tomo {tomo.number} — {tomo.title}
                </span>
                <span className="mt-1 block text-blue-900/70" data-id="element-253" data-mp="2ihmnwph6lt8q">{tomo.detail}</span>
              </span>
            </li>)}
        </ol>

        <div className="mx-auto mt-10 max-w-narrow rounded-2xl bg-white p-7 shadow-soft ring-1 ring-blue-100 md:p-9" data-id="element-254" data-mp="2sfakzm29fcu2">
          <h3 className="font-display text-xl font-extrabold tracking-tight text-blue-600 md:text-2xl" data-id="element-255" data-mp="2xewyzxpwwx3x">
            Cada tomo incluye:
          </h3>
          <ul className="mt-6 grid gap-4 text-left sm:grid-cols-2" data-id="element-256" data-mp="31e5sd1h1isyy">
            {includedFeatures.map(feature => <li key={feature} className="flex items-start gap-3" data-id="element-257" data-mp="3691ke1ma1gc2">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-mint-50 text-mint-600" data-id="element-258" data-mp="3b5a6jyyw69sq">
                  <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-259" data-mp="3g31y2rvmjtwe" />
                </span>
                <span className="text-ink" data-id="element-260" data-mp="3l1li2mqnqvm4">{feature}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}